export const s = {
  name: 'Emlak Turu',
  pitch: 'Şehir al, otel dik, rakibi kirayla batır. Şans kartında istersen gerçek görev yap.',
  settings: {
    readOnly: 'Ayarları oda sahibi seçer.',
    mode: 'Nasıl oynanacak',
    solo: 'Herkes tek',
    teams: 'Takımlı',
    teamCount: 'Takım sayısı',
    teamHint: 'Bir oyuncuya dokununca takımı değişir. Takımlar eşit olmak zorunda değil; seçilmeyenler başlarken dağıtılır.',
    team: (n: number) => `Takım ${n}`,
    unassigned: 'Takımı yok',
    empty: 'Henüz kimse yok',
    shuffle: 'Karıştır',
    minutes: 'Oyun süresi',
    minutesValue: (n: number) => `${n} dk`,
    minutesHint: 'Süre dolunca en zengin kazanır.',
    turnSeconds: 'Hamle süresi',
    secondsValue: (n: number) => `${n} sn`,
    realTasks: 'Gerçek hayat görevleri',
    realTasksHint: 'Açıksa şans kartı çıkınca oyuncu kartı uygulamak yerine görevi seçebilir. Yapamazsa kart uygulanır.',
    on: 'Açık',
    off: 'Kapalı',
    categories: 'Görev paketleri',
    categoriesHint: 'Şans kartlarında yalnızca seçtiğin paketlerden görev çıkar.',
    adultHint: '+18 paket seçtin: görevler yetişkinler içindir, oyuncular istemedikleri görevi kartı uygulayarak atlayabilir.',
    addTask: 'Kendi görevini yaz',
    addPlaceholder: 'Örn: Masanın altından geç',
    addButton: 'Ekle',
    added: (t: string) => `Eklendi: ${t}. Yalnızca sen odadayken çıkar.`,
    addFailed: 'Görev eklenemedi. Tekrar dene.',
  },
  play: {
    boardLabel: 'Emlak Turu oyun tahtası',
    openMap: 'Bütün tahtayı göster',
    closeMap: 'Piyona dön',
    pickTitle: 'Karakterini seç',
    pickHint: 'Figüre ya da adına dokun. Süre dolunca kalanlara otomatik atanır.',
    taken: 'Alındı',
    spectator: 'Bu oyunu izliyorsun.',
    shield: 'Kalkan',
    out: 'İflas',
    turnOf: (name: string) => `${name} oynuyor`,
    actor: (nick: string) => `${nick} oynuyor`,
    roll: 'Zar at',
    moving: 'Zar atılıyor',
    island: 'Kayıp Ada',
    jailLeft: (n: number) => `${n} tur kaldı`,
    jailHint: 'Çift atarsan bedavaya çıkarsın.',
    bail: 'Parayla çık',
    tryDouble: 'Çift dene',
    buyButton: 'Satın al',
    resort: 'Tatil beldesi',
    resortInfo: 'Kira sahip olduğun belde sayısıyla katlanır. 4 belde oyunu kazandırır. Yükseltilemez, geri satın alınamaz.',
    festival: 'Festival: kira 2 kat',
    freeCity: 'Boş şehir',
    yours: 'Senin şehrin',
    thirdLocked: "3. ev için önce Başla'dan geçmelisin.",
    takeover: (name: string) => `${name} senin olsun mu?`,
    takeoverInfo: (name: string) => `${name} aldığı fiyatın iki katını alır, şehir bütün evleriyle sana geçer.`,
    skip: 'Geç',
    waitDecide: (name: string) => `${name} karar veriyor`,
    tour: 'Dünya Turu',
    tourInfo: 'Boş bir şehre, kendi şehrine ya da bir beldeye uç. Tahtadan da seçebilirsin.',
    rollInstead: 'Uçma, zar at',
    cup: 'Şampiyona',
    cupNote: 'Kira katlanır',
    cupInfo: 'Hangi şehrin ev sahibi olsun? Kirası iki katına çıkar, yeni şampiyonayla yeniden katlanır.',
    chance: 'Şans kartı',
    realTask: 'Gerçek görev',
    applyCard: 'Kartı uygula',
    taskWatch: (name: string) => `${name} görevi yapıyor. İzle, sonra oyla.`,
    taskEveryone: 'Herkes sana bakıyor',
    taskDone: 'Bitirdim',
    taskQuit: 'Yapamadım',
    voteTitle: (name: string) => `${name} yaptı mı?`,
    voted: 'Oyun alındı. Diğerleri bekleniyor.',
    voteDone: 'Yaptı',
    voteFailed: 'Yapamadı',
    voteWaiting: (name: string) => `Rakipler ${name} için oyluyor.`,
    voteCount: (d: number, f: number, p: number) => `Yaptı ${d}, yapamadı ${f}, bekleyen ${p}. Eşitlikte görev sayılır.`,
    debt: (amount: string) => `${amount} borcun var`,
    debtInfo: (need: string) => `${need} daha lazım. Şehir sat ya da iflas et.`,
    sell: 'Sat',
    bankrupt: 'İflas et',
    cityFree: 'Sahibi yok',
    cityRent: (rent: string) => `Kira ${rent}`,
    cityPrice: (price: string) => `Boş fiyatı ${price}`,
    levels: ['', '1 ev', '2 ev', '3 ev', 'Otel'],
    close: 'Kapat',
  },
  podium: {
    youWon: 'Kazandın!',
    winner: (n: string) => `${n} kazandı!`,
    tie: (n: string) => `${n} berabere`,
    reason: { time: 'Süre doldu, en zengin kazandı.', last: 'Ayakta kalan son oyuncu.', groups: 'Üç renk grubunu topladı.', side: 'Bir kenarın tamamını topladı.', resorts: 'Dört tatil beldesini topladı.', host: 'Oda sahibi oyunu bitirdi.' },
    cities: (n: number) => `${n} şehir`,
    out: 'İflas etti',
    back: 'Lobiye dönülüyor',
  },
};
